import History from "./History";

export default History;
